import React from 'react';
import { useSelector } from 'react-redux';
import {
  GraphNodeTypes,
  NewGraphNodeItem,
  selectGrabbedItem,
} from '../../../../services/ducks/designerDuck/designerDuck';
import { NODE_HEIGHT, NODE_WIDTH } from '../../../../utils/dimensions';
import { State, ChildWorkflow, Module, Junction } from '../../Canvas/Nodes';

export const DraggedModule = () => {
  const grabbedItem = useSelector(selectGrabbedItem) as NewGraphNodeItem;

  return (
    <div
      id="DraggedModule"
      style={{ padding: '2px', height: NODE_HEIGHT, width: NODE_WIDTH }}
    >
      {!grabbedItem ? null : grabbedItem.type === GraphNodeTypes.STATE ? (
        <State
          id="grabbedModule"
          type="state"
          forReactFlow={false}
          selected={true}
          data={{
            label: (
              <div>{grabbedItem.state ? grabbedItem.state : 'New State'}</div>
            ),
            data: {
              type: GraphNodeTypes.STATE,
              id: '',
              next: [],
            },
          }}
          isConnectable={false}
        />
      ) : grabbedItem.type === GraphNodeTypes.CHILD ? (
        <ChildWorkflow
          id="grabbedModule"
          type="child"
          forReactFlow={false}
          selected={true}
          data={{
            label: (
              <div>
                {grabbedItem.state ? grabbedItem.state : 'New Child Workflow'}
              </div>
            ),
            data: {
              type: GraphNodeTypes.CHILD,
              id: '',
              next: [],
            },
          }}
          isConnectable={false}
        />
      ) : grabbedItem.type === GraphNodeTypes.JUNCTION ? (
        <Junction
          id="grabbedModule"
          type="junction"
          selected={true}
          forReactFlow={false}
          data={{
            label: (
              <div>
                {grabbedItem.state ? grabbedItem.state : 'New Junction'}
              </div>
            ),
            data: {
              type: GraphNodeTypes.JUNCTION,
              id: '',
              next: [],
            },
          }}
          isConnectable={false}
        />
      ) : grabbedItem.type === GraphNodeTypes.MODULE ? (
        <Module
          selected={true}
          forReactFlow={false}
          data={{
            data: {
              pluginUUID: grabbedItem.pluginUUID,
              moduleID: grabbedItem.moduleID,
              type: GraphNodeTypes.MODULE,
              id: '',
              next: [],
            },
          }}
          id="grabbedModule"
          type="module"
          isConnectable={false}
        />
      ) : grabbedItem.type === GraphNodeTypes.GROUP_JUNCTION ? (
        <Module
          selected={true}
          forReactFlow={false}
          data={{
            data: {
              pluginUUID: grabbedItem.pluginUUID,
              moduleID: grabbedItem.moduleID,
              type: GraphNodeTypes.MODULE,
              id: '',
              next: [],
            },
          }}
          id="grabbedModule"
          type="group"
          isConnectable={false}
        />
      ) : null}
    </div>
  );
};
